<ngx-spinner bdColor="rgba(51,51,51,0.55)" size="medium" color="#fff" type="line-spin-clockwise-fade" [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>
<div class="main">
    <div class="col-12">
        <h4 class="title-color">{{ 'setting.time_configuration' | translate }}</h4>
        <hr>
        <div class="row">
            <div class="col-12">
                <fieldset>
                    <form class="w-100" [formGroup]="timeConfigurationForm" (ngSubmit)="setTimeConfiguration()" name="form">
                        <div class="row">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-6">
                                        <h5>{{'general.time_attend' | translate}}</h5>
                                    </div>
                                    <div class="col-6">
                                        <h5>{{'general.time_close' | translate}}</h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3">
                                        <label for="attendHours">{{'general.hour' | translate}}</label>
                                        <select id="attendHours" class="form-control" (change)="onChangeTimeToAttend($event.target.value)" formControlName="attendHours">
                                                <option class = "text-dark" value="" selected>{{'select_hour' | translate}}</option>
                                                <option class = "text-dark" *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
                                            </select>
                                    </div>
                                    <div class="col-3">
                                        <label for="attendMinutes">{{'general.minute' | translate}}</label>
                                        <select id="attendMinutes" class="form-control" formControlName="attendMinutes">
                                                <option class = "text-dark" value="" selected>{{'select_minutes' | translate}}</option>
                                                <option class = "text-dark" *ngFor="let minute of minutes" [value]="minute">{{minute}}</option>
                                            </select>
                                    </div>
                                    <div class="col-3">
                                        <label for="closeHours">{{'general.hour' | translate}}</label>
                                        <select id="closeHours" class="form-control" (change)="onChangeTimeToClose($event.target.value)" formControlName="closeHours">
                                                <option class = "text-dark" value="" selected>{{'select_hour' | translate}}</option>
                                                <option class = "text-dark" *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
                                            </select>
                                    </div>
                                    <div class="col-3">
                                        <label for="closeMinutes">{{'general.minute' | translate}}</label>
                                        <select id="closeMinutes" class="form-control" formControlName="closeMinutes">
                                                <option class = "text-dark" value="" selected>{{'select_minutes' | translate}}</option>
                                                <option class = "text-dark" *ngFor="let minute of minutes" [value]="minute">{{minute}}</option>
                                            </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="row mb-2">
                            <div class="col-12 text-right">
                                <button *ngIf="!editing" class="btn btn-blue btn-h-blue" (click)="edit()">
                                    <i class="fa fa-pencil fa-md pr-1"></i> {{'general.edit' | translate}}
                                </button>
                                <button *ngIf="editing" type="button" class="btn btn-red btn-h-red mr-2" (click)="edit()">
                                    {{'general.cancel' | translate}}
                                </button>
                                <button *ngIf="editing" type="submit" class="btn btn-green btn-h-green">
                                    {{'general.update' | translate}}
                                </button>
                            </div>
                        </div>
                    </form>
                </fieldset>
            </div>
        </div>
    </div>
</div>